import { fetchWithAuth } from "../utils/apiUtils";

export default class SiteService {
    private static sitePath = 'asset/sites';

    constructor() { }

    public static async getSites() {
        return await fetchWithAuth(this.sitePath, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async getSite(siteId: string) {
        return await fetchWithAuth(`${this.sitePath}/${siteId}`, {
            method: 'GET',
            headers: {
                "Content-Type": 'application/json'
            }
        });
    }

    public static async updateSite(siteId: string, data: any) {
        return await fetchWithAuth(`${this.sitePath}/${siteId}`, {
            method: 'PATCH',
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify(data)
        });
    }
}